import { useSyncExternalStore } from "react";
import { onColorSchemeChange, readColorScheme } from "../lib/colorScheme";

export function useColorScheme() {
  return useSyncExternalStore(
    onColorSchemeChange,
    readColorScheme,
    () => "light" as const
  );
}
